import formatName from 'I18n/utils/formatName';
import { PropertyOnlyCategory, PropertyOnlyTokenToCategory, PropertyCategories, HUBSPOT_OWNER_FULL_NAME, HUBSPOT_OWNER_FIRST_NAME, HUBSPOT_OWNER_LAST_NAME } from 'data-token-picker/constants/Properties';
const categoriesWithoutDefaultValues = [PropertyCategories.SITE_SETTINGS, PropertyCategories.SUBSCRIPTION_TYPE, PropertyOnlyCategory];
const isUserProperty = property => {
  if (!property) {
    return false;
  }
  return !!property.isOwnerField;
};
const getCategoryCannotHaveDefaultValue = category => categoriesWithoutDefaultValues.includes(category);
export const propertyCanHaveDefaultValue = (currentOption, selectedUserProperty) => {
  const selectedProperty = currentOption.name;
  const selectedCategory = currentOption.category;
  const isUserPropertyWithoutSelectedUserProperty = isUserProperty(currentOption) && !selectedUserProperty;
  return !!selectedProperty && !isUserPropertyWithoutSelectedUserProperty && !getCategoryCannotHaveDefaultValue(selectedCategory);
};
export const isPropertyOnly = (type, field) => {
  return type === PropertyOnlyCategory && !!PropertyOnlyTokenToCategory[field];
};
export const getOwnerFullName = ({
  parentFieldReference
}) => {
  if (!parentFieldReference) return undefined;
  const firstNameFieldOption = parentFieldReference.children.find(({
    value
  }) => value.includes(HUBSPOT_OWNER_FIRST_NAME));
  const lastNameFieldOption = parentFieldReference.children.find(({
    value
  }) => value.includes(HUBSPOT_OWNER_LAST_NAME));
  return formatName({
    firstName: firstNameFieldOption === null || firstNameFieldOption === void 0 ? void 0 : firstNameFieldOption.parentFieldDefaultValue,
    lastName: lastNameFieldOption === null || lastNameFieldOption === void 0 ? void 0 : lastNameFieldOption.parentFieldDefaultValue
  });
};
export const getOwnerDefaultValue = ({
  fieldReference,
  parentFieldReference
}) => {
  if (!fieldReference) return undefined;
  const isFullNameField = fieldReference.value.includes(HUBSPOT_OWNER_FULL_NAME);
  return isFullNameField ? getOwnerFullName({
    parentFieldReference
  }) : fieldReference.parentFieldDefaultValue;
};

/**
 * For most fields, this is simply the `fieldDefaultValue`.
 *
 * For owner fields, `parentFieldDefaultValue` the value
 * on the fallback user, will override `fieldDefaultValue`;
 * even if `parentFieldDefaultValue` is falsey!
 *
 * Local fallback values will override everything.
 */
export const getDefaultValue = ({
  isOwnerField,
  fieldReference,
  parentFieldReference
}) => {
  const hasGlobalDefaultUser = Boolean(parentFieldReference === null || parentFieldReference === void 0 ? void 0 : parentFieldReference.fieldDefaultValue);
  return isOwnerField && hasGlobalDefaultUser ? getOwnerDefaultValue({
    fieldReference,
    parentFieldReference
  }) : fieldReference === null || fieldReference === void 0 ? void 0 : fieldReference.fieldDefaultValue;
};
export const createTokenString = ({
  path = '',
  defaultValue,
  filter
}) => {
  if (typeof defaultValue !== 'string') {
    return `{{ ${path}${filter ? `|${filter}` : ''} }}`;
  }
  return `{{ personalization_token('${path}', '${defaultValue}')${filter ? `|${filter}` : ''} }}`;
};